var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAllStablecoinImg03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 310,
    height: 220,
    viewBox: "0 0 310 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_944_282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 310,
    height: 220
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 310,
    height: 220,
    rx: 14,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_944_282)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.363 160.354L100.363 127.291L168.227 76.0264L179.363 160.354Z",
    fill: "url(#paint0_linear_944_282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.466 171.281L179.363 160.355L233.845 103.478L205.466 171.281Z",
    fill: "url(#paint1_linear_944_282)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.227 76.0268L102.623 48.576L185.38 35.0303L168.227 76.0268Z",
    fill: "url(#paint2_linear_944_282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M168.227 76.0268L233.845 103.478L185.38 35.0303L168.227 76.0268Z",
    fill: "url(#paint3_linear_944_282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2444 116.365L100.363 127.291L102.623 48.5762L74.2444 116.365Z",
    fill: "url(#paint4_linear_944_282)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.363 127.291L179.363 160.355L122.77 184.647L100.363 127.291Z",
    fill: "url(#paint5_linear_944_282)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M168.227 76.0264L233.845 103.477L179.363 160.354L168.227 76.0264Z",
    fill: "url(#paint6_linear_944_282)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.227 76.0269L102.623 48.5762L100.363 127.291L168.227 76.0269Z",
    fill: "url(#paint7_linear_944_282)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2444 116.364L122.77 184.647L100.363 127.291L74.2444 116.364Z",
    fill: "url(#paint8_linear_944_282)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M205.466 171.281L122.77 184.647L179.363 160.354L205.466 171.281Z",
    fill: "url(#paint9_linear_944_282)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.333 160.354C172.687 157.75 166.041 155.145 159.426 152.451C152.81 149.757 146.209 147.063 139.608 144.339L129.73 140.238L119.866 136.077L100.228 127.545L99.6895 127.32L100.153 126.961L108.685 120.615C111.529 118.504 114.373 116.379 117.187 114.224C122.825 109.943 128.442 105.627 134.04 101.277L150.879 88.2846L167.778 75.3675L168.795 74.5742L168.975 75.8614C169.963 82.8813 170.861 89.9161 171.774 96.951L173.151 107.428L174.438 117.906L177.013 139.22C177.896 146.255 178.659 153.289 179.437 160.339V160.459L179.333 160.354ZM179.333 160.175C178.27 153.2 177.192 146.24 176.219 139.22L173.226 118.175L171.729 107.698L170.322 97.2204C169.379 90.2005 168.436 83.1657 167.553 76.1308L168.765 76.6398L151.717 89.3623L134.549 101.98C128.832 106.186 123.129 110.392 117.471 114.658C114.627 116.768 111.813 118.924 108.999 121.079L100.572 127.545V126.976L120.42 134.969L130.313 139.07L140.177 143.231C146.748 146.015 153.319 148.784 159.86 151.643C166.4 154.502 172.777 157.361 179.258 160.234L179.333 160.175Z",
    fill: "#BB67DF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M205.451 171.341C201.031 169.675 196.63 167.968 192.25 166.222C187.864 164.501 183.494 162.72 179.138 160.923L178.3 160.579L178.929 159.921C181.189 157.541 183.419 155.131 185.709 152.781C187.999 150.431 190.199 148.051 192.579 145.731C197.189 141.061 201.874 136.466 206.424 131.736C208.729 129.401 210.989 127.022 213.234 124.627C215.48 122.232 217.725 119.852 219.97 117.442L233.853 103.444L227.544 120.735L220.419 137.664L213.115 154.532C210.66 160.15 208.165 165.743 205.631 171.311L205.451 171.341ZM205.451 171.176C207.637 165.469 209.857 159.786 212.112 154.128L218.997 137.095L226.047 120.121L233.853 103.444L220.419 117.951C218.114 120.286 215.809 122.621 213.534 124.986C211.259 127.351 208.969 129.701 206.723 132.096C202.233 136.84 197.743 141.72 193.327 146.525C191.112 148.949 188.837 151.314 186.577 153.694C184.317 156.074 182.087 158.409 179.737 160.774L179.527 159.786C183.883 161.627 188.208 163.483 192.519 165.399C196.83 167.315 201.17 169.215 205.451 171.176Z",
    fill: "#BB67DF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M185.454 35.0598C184.227 38.5623 182.895 42.0198 181.563 45.5372C180.231 49.0546 178.794 52.4074 177.417 55.85C176.713 57.5563 175.92 59.2477 175.246 60.954C174.573 62.6604 173.75 64.3367 172.971 66.028L170.681 71.0871C169.903 72.7785 169.185 74.4848 168.451 76.1762L168.361 76.4156L168.137 76.3108C166.775 75.7121 165.398 75.1584 164.036 74.6046L159.905 72.9282L151.568 69.6503C146.044 67.4949 140.566 65.2497 135.103 63.0195L126.916 59.562C124.177 58.4244 121.467 57.227 118.758 56.0296C116.049 54.8322 113.325 53.6348 110.631 52.3925C107.937 51.1502 105.257 49.9078 102.578 48.6356V48.5009C105.362 49.5337 108.161 50.5216 110.93 51.5992C113.699 52.6769 116.453 53.7396 119.207 54.8322C121.961 55.9249 124.73 57.0175 127.455 58.155L135.672 61.5677C141.105 63.9176 146.553 66.2526 151.972 68.6624L160.084 72.3145L164.17 74.0807C165.517 74.6644 166.88 75.2482 168.257 75.802L167.942 75.9366C168.631 74.2154 169.349 72.5091 170.008 70.7729L171.998 65.579C172.672 63.8577 173.301 62.1215 174.019 60.4151C174.738 58.7088 175.396 56.9726 176.129 55.2662C177.626 51.8835 179.033 48.456 180.62 45.0882C182.206 41.7205 183.613 38.3378 185.305 35L185.454 35.0598Z",
    fill: "#BB67DF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M233.89 103.552C233.89 103.552 232.812 103.223 230.896 102.594C229.968 102.28 228.876 101.861 227.588 101.397C226.301 100.933 224.894 100.379 223.338 99.7805C221.781 99.1818 220.12 98.4783 218.368 97.7149C216.617 96.9516 214.806 96.0535 212.92 95.1704C211.034 94.2873 209.088 93.3593 207.068 92.5211C205.047 91.6829 202.967 90.8896 200.871 90.1263C198.776 89.3629 196.695 88.6295 194.66 87.8063L188.672 85.4264C184.811 83.9296 181.189 82.3131 178.195 80.9361C175.201 79.5591 172.657 78.3467 170.906 77.4935L168.167 76.1015V75.9668L171.07 76.9397C172.912 77.5983 175.561 78.4365 178.644 79.7237C181.727 81.0109 185.38 82.343 189.196 84.0044L195.079 86.5938C197.069 87.4919 199.09 88.42 201.066 89.3929C203.041 90.3658 205.107 91.2638 207.128 92.1169C209.148 92.9701 211.154 93.7335 213.115 94.437C215.075 95.1405 216.976 95.8139 218.758 96.5174C220.539 97.2209 222.185 98.0142 223.712 98.6129C225.239 99.2117 226.705 99.9152 227.858 100.514C229.01 101.113 230.148 101.577 231.016 102.011C232.767 102.879 233.755 103.418 233.755 103.418L233.89 103.552Z",
    fill: "#BB67DF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3491 116.335C78.7396 117.981 83.1152 119.677 87.4758 121.424C91.8613 123.145 96.2319 124.926 100.602 126.722L99.7493 127.276C99.7493 123.998 99.8541 120.72 99.9888 117.442C100.123 114.164 100.183 110.871 100.348 107.593C100.632 101.037 101.037 94.4816 101.231 87.9257C101.371 84.6428 101.466 81.3649 101.515 78.092C101.605 74.7991 101.65 71.5212 101.695 68.2433L102.632 48.5908L96.187 65.8185L89.0624 82.7619L81.7581 99.6155C79.3433 105.184 76.8736 110.757 74.3491 116.335ZM74.1844 116.335C76.3697 110.617 78.595 104.914 80.8601 99.2263L87.7452 82.1782L94.795 65.2198L102.632 48.5908L102.488 68.2582C102.339 71.5311 102.209 74.814 102.099 78.1069C101.98 81.3849 101.875 84.6628 101.83 87.9407C101.65 94.4966 101.665 101.067 101.575 107.638C101.575 110.916 101.441 114.194 101.381 117.472C101.321 120.75 101.156 124.028 101.052 127.321V128.219L100.228 127.86C95.8877 126.019 91.547 124.163 87.2363 122.247C82.9256 120.331 78.6149 118.415 74.3192 116.439L74.1844 116.335Z",
    fill: "#BB67DF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M179.348 160.355C170.053 164.68 160.668 168.871 151.298 173.032C146.613 175.143 141.883 177.149 137.184 179.199L123.069 185.336L122.351 185.65L122.081 184.917L116.543 170.563C114.702 165.773 112.816 160.998 111.035 156.179L105.617 141.765C103.865 136.945 102.069 132.141 100.363 127.291C102.384 132.021 104.329 136.766 106.35 141.495L112.143 155.76C114.103 160.504 115.944 165.294 117.845 170.069L123.518 184.378L122.53 183.959L136.69 177.972C141.419 175.966 146.134 173.93 150.879 171.985C160.309 168.033 169.798 164.112 179.348 160.355Z",
    fill: "#BB67DF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_944_282",
    x1: 117.487,
    y1: 93.2498,
    x2: 191.984,
    y2: 134.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_944_282",
    x1: 191.172,
    y1: 117.326,
    x2: 245.991,
    y2: 143.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_944_282",
    x1: 120.561,
    y1: 43.4035,
    x2: 162.397,
    y2: 93.7202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_944_282",
    x1: 182.45,
    y1: 49.0102,
    x2: 243.642,
    y2: 83.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_944_282",
    x1: 80.3957,
    y1: 64.6532,
    x2: 113.946,
    y2: 71.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_944_282",
    x1: 117.487,
    y1: 139.006,
    x2: 175.873,
    y2: 186.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_944_282",
    x1: 182.45,
    y1: 93.2498,
    x2: 249.248,
    y2: 124.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_944_282",
    x1: 115.073,
    y1: 64.6532,
    x2: 181.483,
    y2: 98.7662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_944_282",
    x1: 84.7626,
    y1: 130.311,
    x2: 135.654,
    y2: 151.859,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_944_282",
    x1: 140.695,
    y1: 165.316,
    x2: 160.695,
    y2: 205.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA14F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllStablecoinImg03);
export default __webpack_public_path__ + "static/media/allStablecoin_img_03.e90ea7c6d76316e39e58bb54eaef2f43.svg";
export { ForwardRef as ReactComponent };